import {
  parsePhoneNumber,
  formatPhoneNumber,
  formatPhoneNumberIntl
} from 'react-phone-number-input';
import _get from 'lodash/get';

export default function parsePhone(number = '') {
  const data = parsePhoneNumber(number);

  if (!data) return {};

  const phone = _get(data, 'nationalNumber', '');
  const phoneCountryCode = number.replace(phone, '');

  return {
    phone,
    phoneCountryCode,
    localPhone: formatPhoneNumber(number),
    intlPhone: formatPhoneNumberIntl(number)
  };
}
